export default "__VITE_ASSET__CzO5o9JK__"